export default __webpack_public_path__ + "static/media/logo_transparent.51ab93ff.png";